import(/* webpackMode: "eager" */ "/home/runner/work/SOFAR/SOFAR/app/terms-and-conditions/page.js");
